import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=28b3c2f5"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports